/**
 * Strip salesletter-only `_bundle` line properties when the shopper leaves
 * the letter (e.g. back to PDP/home). Keeps Kindertag / URL packs untouched
 * by only targeting configured property values
 * (default: bundle-sl-28 / -56 / -84, plus legacy bundle-sl).
 *
 * Also: after bundle-sl ATC → checkout, if the shopper returns to the shop
 * (abandons checkout), clear the entire cart (flag from checkout-direct.js).
 */
(function () {
  if (window.__kijimeaBundlePropertyCleanup) return;
  window.__kijimeaBundlePropertyCleanup = true;

  var SOURCE = 'kijimea-bundle-property-cleanup';
  var DEFAULT_PROPERTIES = ['bundle-sl-28', 'bundle-sl-56', 'bundle-sl-84', 'bundle-sl'];
  var CLEAR_ON_RETURN_KEY = 'kijimea-bundle-sl-clear-on-return';

  function cartJsonUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  function cartChangeUrl() {
    return (window.routes && window.routes.cart_change_url) || '/cart/change.js';
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  }

  function cartClearUrl() {
    return '/cart/clear.js';
  }

  function isCheckoutOrOrderPath() {
    var path = (window.location && window.location.pathname) || '';
    return (
      path.indexOf('/checkouts/') !== -1 ||
      path.indexOf('/checkout') !== -1 ||
      path.indexOf('/thank_you') !== -1 ||
      path.indexOf('/orders/') !== -1
    );
  }

  function consumeClearOnReturnFlag() {
    try {
      if (sessionStorage.getItem(CLEAR_ON_RETURN_KEY) !== '1') return false;
      sessionStorage.removeItem(CLEAR_ON_RETURN_KEY);
      return true;
    } catch (e) {
      return false;
    }
  }

  async function clearCartAfterAbandonedCheckout() {
    if (isCheckoutOrOrderPath()) return false;
    if (!consumeClearOnReturnFlag()) return false;

    await fetch(cartClearUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    var fresh = await fetch(cartJsonUrl(), { credentials: 'same-origin' });
    var ajaxCart = await fresh.json().catch(function () {
      return { item_count: 0, items: [] };
    });
    publishCartUpdate(ajaxCart);
    return true;
  }

  function targetProperties() {
    var configured = window.kijimeaSalesLetterBundleProperties;
    if (Array.isArray(configured) && configured.length) {
      return configured.map(String);
    }
    return DEFAULT_PROPERTIES;
  }

  function shouldKeepBundleProperty() {
    // Stay on salesletter (incl. bundle-sl page) → keep property for checkout/discount.
    return document.body && document.body.classList.contains('sales-letter');
  }

  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: SOURCE,
        cartData: cartData,
        skipAutoOpen: true,
      });
    }
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { source: SOURCE, skipAutoOpen: true },
      })
    );
  }

  async function stripBundleProperties() {
    if (shouldKeepBundleProperty()) return;

    var props = targetProperties();
    var cartResponse = await fetch(cartJsonUrl(), { credentials: 'same-origin' });
    var cart = await cartResponse.json().catch(function () {
      return null;
    });
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;

    var tainted = cart.items.filter(function (item) {
      var value = item.properties && item.properties._bundle;
      return value && props.indexOf(String(value)) !== -1;
    });
    if (!tainted.length) return;

    // Remove tainted lines, then re-add same variants without _bundle.
    for (var i = 0; i < tainted.length; i++) {
      var line = tainted[i];
      await fetch(cartChangeUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: String(line.key), quantity: 0 }),
      });
    }

    var readd = tainted.map(function (line) {
      return { id: line.variant_id, quantity: line.quantity || 1 };
    });

    var addResponse = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: readd }),
    });

    if (!addResponse.ok) {
      console.warn('[bundle-property-cleanup] re-add failed');
      return;
    }

    var fresh = await fetch(cartJsonUrl(), { credentials: 'same-origin' });
    var ajaxCart = await fresh.json().catch(function () {
      return null;
    });
    if (ajaxCart) publishCartUpdate(ajaxCart);
  }

  function run() {
    clearCartAfterAbandonedCheckout()
      .then(function (didClear) {
        if (didClear) return;
        return stripBundleProperties();
      })
      .catch(function (error) {
        console.warn('[bundle-property-cleanup]', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // BFCache back-from-checkout: DOMContentLoaded may not re-fire.
  window.addEventListener('pageshow', function (event) {
    if (event && event.persisted) run();
  });
})();
